import createRequestTypes from "../../../../helpers/createReduxActionTypes";

export const GET_CLIENT_PROGRESS = createRequestTypes("GET_CLIENT_PROGRESS");
export const UPDATE_CHECKIN_INFO = "UPDATE_CHECKIN_INFO";
